import { FormGroup, TextArea } from "@blueprintjs/core";
import type { ExtraFieldTypeRichText } from "@package/ui-gql/index-data-access";
import { get, set } from "lodash";
import { useMemo } from "react";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldRichTextProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeRichText;
};

function ServiceDataFormFieldRichTextContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldRichTextProps) {
  const value = useMemo<string>(
    () => get(data, field.source) ?? "",
    [data, field.source],
  );

  return (
    <FormGroup label={field.label}>
      <TextArea
        fill
        autoResize
        value={value}
        onChange={(e) =>
          onSourceChanged((draft) => {
            set(draft, field.source, e.target.value);
          })
        }
      />
    </FormGroup>
  );
}

export function ServiceDataFormFieldRichText({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeRichText") {
    return (
      <ServiceDataFormFieldRichTextContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
